import { required, helpers, maxLength } from "@vuelidate/validators";
import { insertTransaction, updateTransaction, getTransaction, updateTransactionStatus } from "../services/HceTransactionApiService";
import { formatDate } from "@/utils/dataUtils";

const validProposedCompletionDate = (value, siblings) => {
  if (!helpers.req(value)) return true;

  if (!siblings.anticipatedDate) return true;

  const proposedCompletionTimestamp = new Date(value).getTime();
  const anticipatedTimestamp = new Date(siblings.anticipatedDate).getTime();
  return proposedCompletionTimestamp > anticipatedTimestamp;
};

const validAnticipatedDate = (value, siblings) => {
  if (!siblings.proposedCompletionDate) return true;

  const proposedCompletionTimestamp = new Date(siblings.proposedCompletionDate).getTime();
  const anticipatedTimestamp = new Date(value).getTime();
  return anticipatedTimestamp <= proposedCompletionTimestamp;
};

const isAnticipatedDateRequired = (value, siblings) => {
  return !(siblings.includeAnticipatedDate && value === null);
};
export class TxTransactionModel {
  constructor() {
    this.id = null;
    this.title = '';
    this.description = '';
    this.transactionTypeId = null;
    this.transactionType = '';
    this.proposedCompletionDate = null;
    this.anticipatedDate = null;
    // this.dueDate = null;
    this.status = '';
    this.isActive = true;
    this.isNew = true;
    this.createUser = '';
    this.createDate = '';
    this.updateUser = '';
    this.updateDate = '';
  }

  get isGeneralInformationComplete() {
    const requiredFields = [
      this.title,
      this.description,
      this.transactionTypeId,
      this.proposedCompletionDate
    ];

    return requiredFields.every(field => field !== '' && field !== null);
  }

  get formattedProposedCompletionDate() {
    return formatDate(this.proposedCompletionDate);
  }

  get formattedAnticipatedDate() {
    return formatDate(this.anticipatedDate);
  }

  get formattedDueDate() {
    return formatDate(this.dueDate);
  }

  get includeAnticipatedDate() {
    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);
    return this.proposedCompletionDate && this.proposedCompletionDate.getTime() <= thirtyDaysFromNow.getTime();
  }

  get dueDate() {
    if (!this.proposedCompletionDate) return null;
    if (this.includeAnticipatedDate && !this.anticipatedDate) return null;

    const proposedCompletionTimestamp = new Date(this.proposedCompletionDate).getTime();
    const anticipatedTimestamp = this.includeAnticipatedDate && this.anticipatedDate ? new Date(this.anticipatedDate).getTime() : null;
  
    if (!anticipatedTimestamp || (proposedCompletionTimestamp - anticipatedTimestamp) > (30 * 24 * 60 * 60 * 1000)) {
      return new Date(proposedCompletionTimestamp - (30 * 24 * 60 * 60 * 1000));
    }
  
    return new Date(anticipatedTimestamp + (10 * 24 * 60 * 60 * 1000));
  }

  setData(data) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.transactionTypeId = data.transactionTypeId;
    this.transactionType = data.transactionTypeDescription;
    this.proposedCompletionDate = data.proposedCompletionDate ? new Date(data.proposedCompletionDate) : null;
    this.anticipatedDate = data.anticipatedDate ? new Date(data.anticipatedDate) : null;
    this.status = data.status;
    this.isActive = data.isActive;
    this.isNew = false;
    this.createDate = data.createDate;
  }

  static getValidationRules() {
    return {
      title: { required, maxLength: maxLength(50) },
      description: { required, maxLength: maxLength(255) },
      transactionTypeId: { required },
      proposedCompletionDate: { required, validProposedCompletionDate: helpers.withMessage('Date must be after the Date Transaction First Anticipated', validProposedCompletionDate) },
      anticipatedDate: { isAnticipatedDateRequired: helpers.withMessage('Value is required.', isAnticipatedDateRequired) , validAnticipatedDate: helpers.withMessage('Date must be prior to Proposed Completion Date', validAnticipatedDate) },
    };
  }

  async save() {
    if (this.isNew) {
      const id = await insertTransaction(this);
      this.id = id;
      this.isNew = false;
    } else {
      await updateTransaction(this);
    }
  }

  async updateStatus(status) {
    this.status = status;
    await updateTransactionStatus(this.id, status);
  }

  static async fetchTransaction(transactionId) {
    const model = new TxTransactionModel();
    const data = await getTransaction(transactionId);
    model.setData(data);
    return model;
  }

}